import { useEffect } from "react";

/**
 * Mobilde sanal klavye açılınca:
 *   1) görünür alan (visualViewport) küçülür ama çekmece bunu bilmez → odaklanan input klavyenin
 *      ALTINDA kalır, kullanıcı yazdığını göremez;
 *   2) çekmecenin sonundaki alanlara hiç ulaşılamaz, çünkü kaydıracak boşluk kalmaz.
 *
 * Bu hook ikisini de çözer: klavye yüksekliği kadar alt dolgu ekler ve odaklanan alanı
 * görünür alanın ortasına kaydırır.
 *
 * visualViewport desteklenmiyorsa (eski tarayıcı) sessizce devre dışı kalır — davranış bozulmaz.
 */
export function useKeyboardAwareDrawer(open, bodySelector = ".filter-drawer .ant-drawer-body")
{
    useEffect(() => {
        if (!open) return;

        const vv = window.visualViewport;
        const getBody = () => document.querySelector(bodySelector);

        // klavyenin kapladığı yükseklik = pencere yüksekliği - görünür alan yüksekliği
        const applyKeyboardInset = () => {
            const body = getBody();
            if (!body || !vv) return;
            const inset = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
            body.style.paddingBottom = `${16 + inset}px`;
        };

        const onFocusIn = (e) => {
            const body = getBody();
            if (!body || !body.contains(e.target)) return;
            // klavye açılma animasyonu bitmeden ölçüm yanlış çıkar → bir tur bekle
            setTimeout(() => {
                applyKeyboardInset();
                e.target.scrollIntoView({ block: "center", behavior: "smooth" });
            }, 300);
        };

        const reset = () => {
            const body = getBody();
            if (body) body.style.paddingBottom = "";
        };

        document.addEventListener("focusin", onFocusIn);
        document.addEventListener("focusout", reset);
        vv?.addEventListener("resize", applyKeyboardInset);
        vv?.addEventListener("scroll", applyKeyboardInset);

        return () => {
            document.removeEventListener("focusin", onFocusIn);
            document.removeEventListener("focusout", reset);
            vv?.removeEventListener("resize", applyKeyboardInset);
            vv?.removeEventListener("scroll", applyKeyboardInset);
            reset();
        };
    }, [open, bodySelector]);
}
